import { Modal, NavigationTabs, styleClassNames } from '@chocolate-soup-inc/cs-frontend-components';
import { ReactNode, useCallback } from 'react';
import { generatePath, useLocation, useNavigate } from 'react-router-dom';
import { DETAILS_PATH, ENTITY_GIFTS_PATH } from '../../../routes/paths';

export type TShipmentModalProps = {
  children: ReactNode;
  headline?: string;
};

export const ShipmentModal = (props: TShipmentModalProps) => {
  const { children, headline } = props;
  const navigate = useNavigate();
  //const { shipmentId = '0' } = useParams();
  const location = useLocation();
  const state = (location.state as { backPath?: string } | null) || null;

  const closeModal = useCallback(() => {
    navigate(generatePath('../../'));
  }, [navigate]);

  const onBackClick = useCallback(() => {
    if (!state?.backPath) return null;
    navigate(state?.backPath);
  }, [navigate, state]);

  return (
    <Modal onBackClick={state?.backPath ? onBackClick : undefined} closeModal={closeModal} headline={headline} open={true} size='large'>
      <NavigationTabs
        options={[
          {
            leadingIcon: 'info',
            label: 'Details',
            path: generatePath(`../${DETAILS_PATH}`)
          },
          {
            leadingIcon: 'card_giftcard',
            label: 'Gifts',
            path: generatePath(`../${ENTITY_GIFTS_PATH}`)
          }
        ]}
      />
      <div className={styleClassNames.modalTabContent}>{children}</div>
    </Modal>
  );
};
